var map = {
	"./alde-logo.svg": "55a7",
	"./ano-2011-logo.svg": "9915",
	"./cdu-logo.svg": "43c9",
	"./ciu-logo.svg": "b75d",
	"./die-linke-logo.svg": "2c26",
	"./diem25-logo.svg": "391b",
	"./edp-logo.svg": "84df",
	"./egp-logo.svg": "e309",
	"./epp-logo.svg": "ef9a",
	"./euromat-logo.svg": "d455",
	"./european-left-logo.svg": "01b9",
	"./european-spring-logo.svg": "b84c",
	"./fdp-logo.svg": "f6a6",
	"./fisumat-logo.svg": "6e64",
	"./fitomat-logo.svg": "23dc",
	"./grune-logo.svg": "9174",
	"./jef-logo.svg": "ec1a",
	"./linke-logo.svg": "cb7f",
	"./neos-logo.svg": "411f",
	"./ovld-logo.svg": "043b",
	"./pes-logo.svg": "43893",
	"./piraten-logo.svg": "3532",
	"./pirates-logo.svg": "7bf9",
	"./poe-colored-logo.svg": "7d18",
	"./poe-logo.svg": "f959",
	"./polis-colored-logo.svg": "4cce",
	"./polis-logo.svg": "f6ab",
	"./spd-logo.svg": "8e03",
	"./tierschutzpartei-logo.svg": "d7a9",
	"./volt-logo.svg": "eba7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8477";